import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        //? for debug: console.log(payload.points);
        let result = await apiClient(config).apiMethod({
            method: 'GetGame',
            args: {
                points: payload.points,
                outcome: payload.outcome,
            },
        });

        return result;
    };
};
